import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Viewport from './core/Viewport';
import Components from './core/Components';
import lazySizes from './lib/lazysizes';
import ViewportHeight from './lib/ViewportHeight';
import ScrollToTarget from './lib/ScrollToTarget';
import ScrollReveal from './lib/ScrollReveal';

gsap.defaults({ overwrite: 'auto' });
gsap.registerPlugin(ScrollToPlugin);

const init = () => {
    Viewport.init();
    Components.init();
    Viewport.initTabbing();
    ViewportHeight.init();
    ScrollToTarget.init();
    ScrollReveal.init();
    lazySizes.init();
};

require('doc-ready')(init);
